module.exports = __webpack_public_path__ + "static/media/3.d4e631c8.jpg";